module.exports = __webpack_public_path__ + "img/SSWS_Pearl_sword.467d0d5d.png";